export const shiftBulkCacheKeys = {
  action: {
    delete: () => ['bulk_delete_shifts'] as const,
    validate: () => ['bulk_validate_shifts'] as const,
    invalidate: () => ['bulk_invalidate_shifts'] as const
  }
}
